import { FC } from 'react';

import { Loading } from '@shared/components/Loading';

//* lazy 라우트 청크를 받는 동안의 자리표시자 — 화면 가운데에 공용 스피너
export const RouteFallback: FC = function RouteFallback() {
  return (
    <div role="status" className="center-box min-h-[40vh] w-full">
      <Loading text="불러오는 중" />
    </div>
  );
};
